export default __webpack_public_path__ + "static/media/Copperplate.43c1217f.ttc";